import { createContext, useContext } from "react";

/**
 * The two left columns — the nav rail and the list — are hidden from the shell, so a keyboard
 * shortcut can reach both and the list can put its own toggle in its header.
 */
export interface Chrome {
  navCollapsed: boolean;
  setNavCollapsed: (value: boolean) => void;
  listHidden: boolean;
  setListHidden: (value: boolean) => void;
}

export const ChromeContext = createContext<Chrome>({
  navCollapsed: false,
  setNavCollapsed: () => {},
  listHidden: false,
  setListHidden: () => {},
});

export function useChrome(): Chrome {
  return useContext(ChromeContext);
}
